package pt.at.oss.kotlin.core.i18n

/**
 * Interface for Kotlin-defined translation enums
 */
interface I18nBase {

    val translations: Map<PageLocale, String>

    /**
     * Returns the translation in the given locale or the key if no translation is found for that locale
     **/
    fun get(pageLocale: PageLocale): String {
        return translations[pageLocale] ?: name
    }

    val getFn: (PageLocale) -> String
        get() = this::get

    val name: String
}
